module.exports = __webpack_public_path__ + "img/es.afff2473.svg";